<template>
  <section class="section-two bg-light mt-5 mb-2">
    <div class="container-fluid">

      <div class="row m-3 justify-content-center">
        <div class="col-md-10">
          <div class="row">
            <div class="col-8">
              <p class="h4">
                <b>Escolha o laboratório</b>
              </p>
            </div>
            <div class="col-4 mb-3 text-end">
              <button type="button" class="btn btn-outline-primary btn-sm"
                      @click="$router.back()">
                <i class="fa fa-arrow-left"></i> Voltar
              </button>
            </div>
          </div>

          <div class="mb-4">
            <div class="form-icon position-relative">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                   stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                   class="feather feather-search fea icon-sm icons">
                <circle cx="11" cy="11" r="8"></circle>
                <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
              </svg>
              <input name="city" id="city" class="form-control ps-5" placeholder="Pesquisar laboratório"
                     v-model="search">
            </div>
          </div>

          <div class="row">
            <div class="col-md-12" v-for="place in places" :key="place.id">

              <div class="card shadow rounded border-0 mb-3 pricing-rates business-rate">
                <div class="ribbon ribbon-right ribbon-warning overflow-hidden" v-if="place.recommended">
                  <span class="text-center d-block shadow small h6">Sugestão</span>
                </div>

                <div class="card-body">
                  <div class="row">
                    <div class="col-12 col-md-6">
                      <div class="d-flex align-items-start mb-3">
                        <img v-if="place.place_logo"
                             :src="place.place_logo"
                             class="me-3 rounded" style="height: 4rem"
                             alt="Logo do local">

                        <img v-else src="../../../assets/images/no-photo.png"
                             class="me-3 rounded" style="height: 4rem"
                             alt="Logo do local">

                        <div>
                          <h5 class="mb-1 text-primary fw-bold">{{ place.place_name }}</h5>
                          <small class="text-muted">
                            {{ place.place_phone }}
                          </small>
                        </div>
                      </div>

                      <div class="mb-2 mt-2">
                        <a
                          :href="'https://www.google.com/maps/search/?api=1&query='+place.place_latitude+','+place.place_longitude"
                          class="text-decoration-none text-primary">📍 Abrir no mapa</a>
                        <p class="mb-1 text-muted">{{ place.place_full_address }}</p>
                      </div>

                      <div class="row g-2 align-items-center my-3">
                        <div class="col-12 col-sm-auto">
                          <span class="fw-bold fs-5">R$ {{ Number(place.total_value).toFixed(2) }}</span>
                          <small class="text-muted ms-1">em até 12x</small>
                        </div>
                        <div class="col-12 col-sm-auto">
                          <button type="button"
                                  :title="place.item_values.length !== examsCart.length ? 'Esse local não realiza todos os exames.' : ''"
                                  :class="place.item_values.length !== examsCart.length ? 'btn-outline-warning' : 'btn-outline-primary'"
                                  class="btn w-100" @click="showExamsPlace(place)"
                                  data-bs-target="#ExamModalCart" data-bs-toggle="modal">
                            Ver exames ({{ place.item_values.length }}/{{ examsCart.length }})
                          </button>
                        </div>
                      </div>

                    </div>
                    <div class="col-12 col-md-6">
                      <div class="text-center fw-bold fs-5">
                        Horários de Atendimento
                        <hr>
                      </div>

                      <div class="row g-3">
                        <div v-for="(avails, dayName) in groupBy(place.place_avails, 'week_day_name')" :key="dayName" class="col-12 col-md-6">
                          <div class="card shadow-sm h-100">
                            <div class="mx-3 my-1">
                              <h5 class="card-title text-center">{{ dayName }}</h5>
                              <div
                                v-for="(avail, index) in avails"
                                :key="index"
                                class="mb-2"
                              >
                                <button
                                  class="btn btn-outline-primary w-100"
                                  @click="selectPlace(place, { id_availability: avail.id_avail, dsc_availability: avail.time_begin + ' às ' + avail.time_end })"
                                >
                                  {{ avail.time_begin }} às {{ avail.time_end }}
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <small>* Em caso de feriados, por favor, entre em contato com a unidade para confirmar o funcionamento.</small>
                    </div>

                  </div>

                </div>
              </div>

            </div>
          </div>

        </div>
      </div>
    </div>

    <div class="modal fade" id="ExamModalCart" tabindex="-1" aria-labelledby="ExamModalCart" aria-hidden="true">
      <div class="modal-dialog modal-lg modal-dialog-centered">

        <div class="modal-content rounded shadow border-0">
          <div class="modal-header border-bottom">
            <h5 class="modal-title">Exames atendidos</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div class="card shadow rounded border-0 mb-3 pricing-rates business-rate" v-for="exam in examsCart">
              <div class="ribbon ribbon-right ribbon-warning overflow-hidden"
                   v-if="examsPlaceSupported.findIndex(item => item.id_item === exam.id_item) === -1">
                <span class="text-center d-block shadow small"
                      style="background-color: #e43f52 !important">Não atende</span>
              </div>
              <div class="m-3">
                <h4 class="fw-bold">
                  <span class="fw-bold h4" v-if="exam.item_name">{{ exam.item_name }} <br></span>
                  <span class="fw-bold h4">{{ exam.exam_name }}</span>
                </h4>
                <p>
                  <b>Código: </b> {{ exam.exam_tuss_code }} <br>
                  <span class="text-truncate-2">{{ exam.item_description }}</span>
                  <span v-if="examsPlaceSupported.findIndex(item => item.id_item === exam.id_item) !== -1">
                    <b>Valor: </b> R$ {{ Number(examsPlaceSupported.find(item => item.id_item === exam.id_item).item_value).toFixed(2) }}
                  </span>
                </p>
                <hr>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import http from "@/helpers/http";

export default {
  name: "ScheduleExamPlaces",
  data() {
    return {
      search: '',
      places: [],
      examsPlaceSupported: [],
      examsCart: [],
    }
  },
  mounted() {
    this.getPlaces();
    this.examsCart = this.$store.state.toSchedule.schedule.exams ?? [];
  },
  methods: {
    getPlaces() {
      http.get('/schedule/exams/places', {
        params: {
          id_items: this.$store.state.toSchedule.schedule.exams.map(e => e.id_item),
          id_place: this.$store.state.toSchedule.place?.id_place,
          id_paymeth: this.$store.state.toSchedule.schedule.paymentMethod.id_paymeth,
          id_city: this.$store.state.toSchedule.schedule.city?.id_city,
          id_insurance: this.$store.state.toSchedule.schedule.insurance?.id_insurance,
        }
      }).then((response) => {
        this.places = response.data;
      });
    },
    selectPlace(place, availability) {
      this.$store.commit('toSchedule/setPlaceSchedule', {...place, availability: availability});
      this.$store.commit('toSchedule/selectAvailability', {
        availabilityTime: {avail_online: false},
        professional: {id_place: place.id_place}
      });

      this.$store.commit('toSchedule/selectCancelingPolicy', {value: place.total_value});

      if (this.$store.getters['auth/isAuth']) {
        this.$router.push('/exams/patients');
      } else {
        this.$router.push('/schedule/pre-signin?callback=exams');
      }
    },
    showExamsPlace(place) {
      this.examsPlaceSupported = place.item_values ?? [];
    },
    groupBy(avails, key) {
      const groups = {};
      avails.forEach(avail => {
        const day = avail[key];
        if (!groups[day]) {
          groups[day] = [];
        }
        groups[day].push(avail);
      });
      return groups;
    },
  }
}
</script>

<style scoped>

</style>